import scReactHarness from './scReactHarness';
import ProductListApp from './components/ProductList/ProductListApp';
import AddToCartClickFunction from './components/AddToCart/AddToCartClick';

// For React Components
scReactHarness({
    ProductListApp
});

// For non-React Components
jQuery(document).ready(function ($) {
    //AddToCartClickFunction.init();
});